import { useEffect } from "react";
import { useLocation } from "wouter";
import { useAuth } from "@/contexts/auth";

interface AdminProtectedRouteProps {
    path: string;
    component: React.ComponentType<any>;
}

export function AdminProtectedRoute({ component: Component }: AdminProtectedRouteProps) {
    const { user, isLoading } = useAuth();
    const [, navigate] = useLocation();

    useEffect(() => {
        if (!isLoading) {
            if (!user) {
                navigate("/login");
            } else if (!user.isAdmin) {
                navigate("/login");
            }
        }
    }, [user, isLoading, navigate]);

    if (isLoading) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-purple-50 to-blue-50 flex items-center justify-center">
                <div className="w-16 h-16 border-4 border-purple-600 border-t-transparent rounded-full animate-spin" />
            </div>
        );
    }

    if (!user || !user.isAdmin) {
        return null;
    }

    return <Component />;
} 